export enum TabKey {
  GENERATE = 'generate_tab',
  HISTORY = 'history_tab'
}

export const FETCH_LIMIT = 30

export enum ReferenceMode {
  FRAMES = 'frames',
  IMAGES = 'images'
}
